import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "prototype"
    }}>{`Prototype`}</h1>
    <p>{`We build the DOM APIs with a lot of intent and care to work around expectations Photoshop may have when a command is being `}<a parentName="p" {...{
        "href": "./batchplay"
      }}>{`batchPlayed`}</a>{`. `}</p>
    <p>{`Photoshop is full of functionality and while we strive to bring all of them into the user-friendly DOM, some may not be ready as you're writing your plug-ins.`}</p>
    <p>{`Further, you may have a different or unique way of scripting Photoshop and may want to add more properties and methods to the provided DOM classes.`}</p>
    <p>{`This is where `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Objects/Object_prototypes"
      }}>{`prototypes`}</a>{` come in to play. In JavaScript, prototypes define what methods and properties are inherited by an object. Properties can be attached to a prototype to ensure that every instance of that object will have those properties. `}</p>
    <p>{`You can overload the many classes' prototype at the start or launch of your plugin or via a library you wrote that is loaded before your code.`}</p>
    <p>{`As a plug-in developer, you have access to these prototypes:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../classes/photoshop"
        }}>{`app.Photoshop`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../classes/document"
        }}>{`app.Document`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../classes/layer"
        }}>{`app.Layer`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../classes/actionset"
        }}>{`app.ActionSet`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../../classes/action"
        }}>{`app.Action`}</a></li>
    </ul>
    <p>{`For example, suppose you want to add a new method to `}<a parentName="p" {...{
        "href": "../../classes/document"
      }}>{`Document`}</a>{` which renames all layers, prepending '_' to them. You can run the following at the start of your plug-in.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`require('photoshop').app.Document.prototype.prependLodash = function () {
  // \`this\` will be the instance of Document you're calling the method on
  this.layers.forEach(l => {
    l.name = '_' + l.name
  })
}
`}</code></pre>
    <p>{`Then, when you want to perform this on any document, you can call it on the instance of that document:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`require('photoshop').app.activeDocument.prependLodash() // All layers in the document will be renamed
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      